var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAlerts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81464 4.80526L9.82284 4.79122L9.83011 4.77668C10.2217 3.99344 11.0206 3.5 11.8965 3.5C12.7726 3.5 13.5706 3.99358 13.9582 4.77523L13.9658 4.79052L13.9744 4.80526L21.0532 16.9243C21.4027 17.6385 21.3616 18.4818 20.9448 19.1543L20.9434 19.1566C20.5277 19.8357 19.7837 20.25 18.9841 20.25H4.80887C4.00954 20.25 3.26462 19.8358 2.84478 19.1552C2.42688 18.4777 2.3869 17.634 2.73564 16.9247L9.81464 4.80526Z",
    stroke: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17C13 17.5524 12.5524 18 12 18C11.4476 18 11 17.5524 11 17C11 16.4476 11.4476 16 12 16C12.5524 16 13 16.4476 13 17Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7C12.5524 7 13 7.46471 13 8.03824V12.9618C13 13.5353 12.5524 14 12 14C11.4476 14 11 13.5353 11 12.9618V8.03529C11 7.46471 11.4476 7 12 7Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlerts);
export default __webpack_public_path__ + "static/media/ic_alerts.c4011528e30fa87d78159008a5f778a1.svg";
export { ForwardRef as ReactComponent };